const data: any = {
  rt: {
    "b": {
      "thisOpponent": "this opponent",
      "firstMatch": "First match",
      "lastMatch": "Last match · {{value}}",
      "oneRated": "vs {{name}} {{value}} · 1 rated match",
      "average": "vs {{name}} {{value}} · {{count}} matches",
      "oneRatedMe": "vs me {{value}} · 1 rated match",
      "averageMe": "vs me {{value}} · {{count}} matches",
      "comparisonControls": "Historical comparisons",
      "showH2H": "Head-to-head averages",
      "showOverall": "Overall averages from all matches"
    },
    "f": {
      "shot_accuracy": "Shot accuracy",
      "call_accuracy": "Call accuracy (in/out)",
      "confrontational_tendency": "Confrontational tendency",
      "forehand": "Forehand",
      "backhand": "Backhand",
      "service": "Serve",
      "return": "Return",
      "volley": "Volley",
      "smash": "Smash",
      "drop_shot": "Drop shot",
      "lob": "Lob",
      "stamina": "Stamina",
      "speed": "Speed",
      "court_coverage": "Court coverage",
      "tactics": "Tactics",
      "awareness": "Court awareness",
      "shot_variety": "Shot variety",
      "winners": "Winners",
      "unforced_errors": "Unforced errors",
      "fh_topspin": "Forehand topspin",
      "fh_slice": "Forehand slice",
      "bh_topspin": "Backhand topspin",
      "bh_slice": "Backhand slice",
      "first_serve": "1st serve",
      "first_serve_speed": "1st serve speed",
      "second_serve": "2nd serve",
      "second_serve_speed": "2nd serve speed",
      "serve_flat": "Flat serve",
      "serve_kick": "Kick serve",
      "serve_slice": "Slice serve",
      "first_serve_pct_est": "1st serves in (est.)",
      "second_serve_pct_est": "2nd serves in (est.)",
      "passing_shots": "Passing shot",
      "volley_d": "Volley",
      "tactics_d": "Tactics",
      "speed_d": "Speed",
      "stamina_d": "Stamina",
      "composure": "Composure",
      "concentration": "Concentration",
      "calmness": "Calmness",
      "anxiety": "Anxiety",
      "confidence": "Confidence",
      "fighting_spirit": "Fighting spirit",
      "mental_resilience": "Mental resilience",
      "belief_pre": "Belief in winning before the match",
      "belief_in": "Belief in winning during the match"
    },
    "g": {
      "movement": "Movement & positioning",
      "behaviour": "Behaviour",
      "forehand": "Forehand",
      "backhand": "Backhand",
      "serve": "Serve",
      "rally": "Rally & return",
      "net": "Net game",
      "physical": "Physical & tactics"
    },
    "h": {
      "shot_accuracy": "How consistently did your shots go where you intended?",
      "call_accuracy": "How accurate do you think your own in/out calls were?",
      "confrontational_tendency": "Tendency toward disputes, tension or confrontation with the opponent."
    },
    "dist": {
      "winnersIncl": "Winners (incl. aces)",
      "unforcedIncl": "Unforced errors (incl. double faults)",
      "assignTo": "Assign remaining {{n}}% to…",
      "countHint": "You logged {{a}} aces and {{d}} double faults.",
      "remainingInline": "Remaining {{n}}%",
      "complete": "Complete — 100% assigned",
      "assignRemainder": "Assign remaining {{n}}% here",
      "tab": "Points",
      "title": "How did the points end?",
      "helper": "Your own estimate — no point-by-point tracking needed. Rough numbers are fine; leave it empty if you'd rather skip it.",
      "winners": "Winners",
      "forced": "Forced errors",
      "unforced": "Unforced errors",
      "df": "Double faults",
      "total": "Total",
      "remaining": "{{n}}% unassigned",
      "over": "{{n}}% over 100",
      "myTeam": "My team",
      "oppTeam": "Opposing team"
    }
  },
  onboarding: {
    eyebrow: "Get started",
    valueHistory: "Build your complete match history",
    valueStats: "Understand your statistics",
    valueImprove: "Track your improvement over time",
    showMore: "How it works & features",
    showLess: "Show less",
    headlineDashboard: "Your dashboard is waiting for its first match",
    headlineMatches: "Log a match to start your tennis history",
    headlineStats: "Stats unlock after your first match",
    intro: "Tennis Log turns every match you play into insight. Log your first one in under a minute and watch your dashboard, charts and AI coach come alive.",
    cta: "+ Log your first match",
    howTitle: "How it works",
    s1Title: "Add a match",
    s1Desc: "Tap “New match”, fill in date, opponent, court and set scores. Drop-downs make it fast.",
    s2Title: "Add detail (optional)",
    s2Desc: "Start with Fast Track to save the essentials, then add Score Timeline, Opponent, Context, Performance Review and Smartwatch details as you want.",
    s3Title: "See your stats",
    s3Desc: "Win rate, hold rate, break rate, sets, games, surface, court, opponent — everything updates instantly.",
    s4Title: "Get AI insights",
    s4Desc: "AI analysis is available once you have logged match data and generally becomes more informative as your match history grows.",
    benefitsTitle: "What you'll see once you log matches",
    b1Title: "Overall win rate",
    b1Desc: "Filter by year, format (singles / doubles / mixed) and kind (friendly / official). Spot trends across seasons.",
    b2Title: "Sets, games, hold & break rate",
    b2Desc: "Beyond W/L: see how often you hold serve, how often you break, your set differential and your game balance.",
    b3Title: "Smartwatch stats",
    b3Desc: "Upload one screenshot from Mi Fitness, Garmin, Apple Watch or Zepp and AI fills calories, BPM and HR zones.",
    b4Title: "Game-by-game heatmap",
    b4Desc: "Discover whether you choke on game 3 or close out game 11 — broken down by serving side and set.",
    b5Title: "Performance ratings",
    b5Desc: "Rate forehand, backhand, serve, return, volley, awareness, court coverage and more. See it on a radar chart.",
    b6Title: "AI coach",
    b6Desc: "A personal narrative of your strengths, weaknesses and patterns — written like a coach, based on your data.",
    tipsTitle: "Tips for your first entry",
    tip1: "Start small: just date, opponent and set scores is enough.",
    tip2: "Add the court and surface — over time you'll see where you play best.",
    tip3: "Try one game-by-game set to unlock hold rate and per-game heatmaps.",
    tip4: "Rate yourself honestly — even a few entries fuel the AI coach.",
    tip5: "Came back from old matches? Log them too. History makes the stats.",
  },
  nav: { dashboard: "Dashboard", matches: "Matches", add: "New match", stats: "Stats", insights: "AI Insights", logout: "Sign out" , settings: "Settings", invite: "Invite a friend" },
  brand: { name: "My Tennis Ledger", tagline: "Get better by studying your tennis history" },
  auth: { age16: "I confirm I am at least 16 years old. Tennis Log accounts are for people aged 16 and over.", age16Required: "Please confirm you are at least 16 years old.", signIn: "Sign in", signUp: "Sign up", email: "Email", password: "Password", name: "Name", createAccount: "Create account", or: "or", continueGoogle: "Continue with Google", welcomeBack: "Welcome back!", accountCreated: "Account created!", passwordInfoLabel: "Password requirements", passwordHelp: "Use at least 8 characters. Uppercase letters, numbers or symbols are not required, but avoid very common or easy-to-guess passwords. Passwords that have appeared in known data breaches are not accepted.", passwordTooShort: "Password must be at least 8 characters.", passwordWeakLeaked: "This password is too common or has appeared in a known data breach. Try a more unique password.", passwordRejected: "This password wasn't accepted. Check the requirements next to the field and try again.", passwordMinLabel: "At least 8 characters", requirementMet: "requirement met", requirementNotMet: "requirement not met yet", sameMethodHint: "Use the same sign-in method you used when creating your account.", signInFailed: "Email or password is incorrect. If you created your account with Google, sign in with Google." },
  authPage: {
    heroTitle: "Start building your tennis history",
    heroSubtitle: "Log matches in a few minutes, track your patterns, and let your stats show what to improve next.",
    trustFree: "Free core features",
    trustData: "Your data stays yours",
    trustDevice: "Works on phone and web",
    dashboardAlt: "Tennis Log dashboard showing win rate, sets, games and hold percentage",
    dashboardCaption: "After a few matches, your dashboard starts showing win rate, hold rate, break points, trends and AI insights.",
    founderQuote: "I built Tennis Log because I wanted to stop forgetting my own matches. All it takes is playing, remembering the score progression, and recording it. I'm confident it will be useful to you too. Enjoy it!",
    founderTitle: "Founder of Tennis Log — My Tennis Ledger",
    founderLocation: "Advanced club-level player, Greece",
    notReadyTitle: "Not ready to sign up yet?",
    notReadySub: "Explore the public content first — all open, no account needed.",
    viewDemoTitle: "View the public demo",
    viewDemoDesc: "See what Tennis Log reveals after ~25 matches — with real charts.",
    readGuideTitle: "Read the Tennis Statistics Guide",
    readGuideDesc: "Which stats actually matter, and how to read them.",
    browseBlogTitle: "Browse the Blog",
    browseBlogDesc: "Articles on hold/break, win-rate trend, smartwatch, AI insights and mental game.",
    open: "Open",
  },
  common: {
    all: "All", singles: "Singles", doubles: "Doubles", mixed: "Mixed",
    friendly: "Friendly", official: "Official",
    me: "Me", opponent: "Opponent", year: "Year", draw: "Draw",
    cancel: "Cancel", save: "Save", saving: "Saving...", loading: "Loading...",
    delete: "Delete", edit: "Edit", search: "Search", close: "Close",
    matches: "matches", other: "Other (specify)",
    loadFailed: "Couldn't load your data", loadFailedBody: "Something went wrong while loading. Check your connection and try again.", retry: "Try again",
  },
  conditions: { sun: "Sun in eyes", wind: "Wind", noise: "Noise / crowd", cold: "Cold", rain: "Rain", slippery: "Slippery court", humidity: "Humidity", strong_wind: "Strong wind" },
  dashboard: {
    title: "Dashboard",
    subtitle: "Your season at a glance.",
    newMatch: "+ New match",
    statsFilter: "Stats filter",
    trendFilter: "Trend filter",
    trendTitle: "Win rate trend",
    recent: "Recent matches",
    seeAll: "All →",
    noMatches: "No matches yet.",
    addFirst: "Add the first one",
    noFilter: "No matches for this filter.",
    overallWinRate: "Overall win rate", winRate: "Win rate", clickDot: "Click dot to edit match",
    sets: "Sets", games: "Games", holdRate: "Hold rate",
    breaksWon: "Breaks won", breaksWonSub: "{{breaks}} of {{total}} return games",
    serviceGames: "service games", returnGames: "return games",
    winAfterFirstSet: "Win after winning 1st set", winAfterFirstSetSub: "{{wins}} of {{total}} matches", surfaceFilter: "Surface",
    setsWon: "Sets won", gamesWon: "Games won", breakRate: "Break rate",
    currentForm: "Current form", formEmpty: "No completed matches yet",
    trendDelta: "Win rate {{pp}} pp vs previous 10",
    trendStable: "Win rate stable vs previous 10",
    trendUnavailable: "Trend available after {{count}} matches",
    discovery: {
      title: "What your tennis is telling you",
      family: { improving: "Improving", edge: "Your edge", watch: "Watch this" },
    },
  },
  match: {
    opponentPrivacyHint: "Optional. These notes are about another person — add only what helps your own analysis, and keep it factual.",
    basics: "Basics", players: "Players", score: "Score per set",
    invalidSetScore: "Impossible score in set {{set}} — the winner must reach the target and lead by 2.", notes: "Notes",
    watch: "Smartwatch data", rating: "Match rating (1–10)",
    surface: "Surface", temperature: "Temperature ({{unit}})",
    setType: "Set type", standardSet: "Standard", shortSet: "Short Set (to 4)", superTb: "Super TB (10p)", tb7: "Tie-break 7p", tb11: "Tie-break 11p",
    tbPointByPoint: "Point-by-point", tbUndo: "Undo", tbClear: "Clear", tbDecided: "Decided",
    date: "Date", time: "Time", day: "Day", court: "Court", courtCustomPlaceholder: "e.g. Club Court #1",
    format: "Match format", kind: "Match kind",
    set: "Set", firstServer: "First server:",
    missingOpponent: "Add your opponent's name to save the match.", missingCourt: "Add the court name to save the match.",
    opponentRequired: "Opponent *", myPartner: "My partner", oppPartner: "Opponent's partner",
    teams: "Teams", teamsHint: "My team (me + partner) vs opponent team (opponent 1 + opponent 2).",
    myTeam: "My team",
    opponentTeam: "Opposing team",
    opponent1: "Opponent 1",
    opponent2: "Opponent 2",
    doublesPlayersRequired: "Add your partner and both opponents to save a doubles match.",
    age: "Age", experience: "Years of experience", backhand: "Backhand", playstyle: "Playstyle",

    notesPlaceholder: "How did the match go?",
    summaryTab: "Summary", detailedTab: "Detailed",
    watchHint: "Upload a screenshot from Mi Fitness/Garmin/Apple Watch and fields will auto-fill via AI.",
    ratingHint: "Leave blank what you don't want to rate.",
    saveMatch: "Save match", saveChanges: "Save changes",
    addTitle: "New match", addSubtitle: "Fill in the details. Drop-downs for speed.",
    editTitle: "Edit match", editSubtitle: "Update details and save.",
    saved: "Match saved!", changesSaved: "Changes saved!", notFound: "Match not found",
    retired: "Was there a retirement?",
    retiredNone: "No",
    retiredYes: "Yes",
    specialEnding: "Special ending",
    scoreMismatchTitle: "Score doesn't match",
    scoreMismatchBody: "Your game-by-game progression adds up to {{derived}}, but the final score says {{declared}}. Check it before continuing.",
    scoreMismatchFix: "Fix final score",
    declaredScore: "Score you declared",
    declaredScoreHint: "This is the final score from Step 1. Now tell us how the set unfolded.",
    declaredScorePrompt: "You declared that <highlight>Set {{set}} ended {{score}}</highlight>. Now tell us how the score unfolded.",
    incompleteSetTimePrompt: "You declared that <highlight>Set {{set}} reached {{score}}</highlight> but did not finish, most likely because time ran out. Enter only the games that were played so they can be included in Elo.",
    timelineLiveScore: "Live game-by-game score",
    scoreMismatchBlock: "The game-by-game score doesn't match the final score. Fix the mismatch before continuing.",
    gameSequenceNext: "Enter games in order · Next: Game {{game}}",
    gameSequenceGap: "Game {{missing}} is missing before Game {{later}}. Fill it in first.",
    gameSequenceBlock: "Complete the missing games in order before continuing.",
    retiredMe: "I retired",
    retiredOpp: "Opponent retired",
    doubleFaults: "Double faults",
    dfMe: "My double faults",
    dfOpp: "Opponent double faults",
    aces: "Aces",
    acesMe: "My aces",
    acesOpp: "Opponent aces",
    context: "Context & conditions",
    contextHint: "External and personal factors that may have affected play.",
    conditions: "Physical conditions",
    personalIssues: "Personal difficulties",
    personalIssuesPlaceholder: "e.g. headache, knee pain, jet lag…",
    psychTab: "Psychology",
    oppAge: "Opponent age",
    oppBackhand: "Opponent backhand",
    bhSingle: "Single-handed",
    bhDouble: "Double-handed",
    oppPlaystyle: "Playstyle",
    styleOffensive: "Offensive",
    styleDefensive: "Defensive",
    styleAllCourt: "All-court",
    floodlights: "Under floodlights",
    rainy: "Rainy weather",
    tiringDay: "Tiring day / hard day at work",
    napped: "Napped at midday",
    heavyMeal: "Heavy meal",
    fasted: "I was fasted",
    anxiousFlag: "Anxious",
    tournamentRound: "Tournament round",
    tournamentName: "Tournament name",
    sleepHours: "Sleep last night (hours)",
    ballsState: "Balls condition",
    ballsNew: "New", ballsUsed: "Used",
    ballsUseCount: "How many times used",
    ballsUseSuffix: "x",
    oppExperience: "Years of experience",
    racketStrungAt: "Racket strung on",
    racketStrungAgo: "{{n}} days ago",
    racketStrungToday: "today",
    individualConditions: "Personal conditions",
    daysSinceLastMatch: "Days since last match",
    daysAgo: "{{n}} days ago",
    ballsUsed1: "Used 1x", ballsUsed2: "Used 2x", ballsUsed3: "Used 3x",
    oppHandedness: "Handedness", righty: "Right-handed", lefty: "Left-handed",
    weightKg: "Weight ({{unit}})", bmi: "BMI", bmiNoHeight: "Set your height in profile to compute BMI",
    hLegend: "H = Hold", bLegend: "B = Break",
    cellHowTo: "Tap the server's cell once for Hold (H), tap again for Break (B). Tap once more to clear.",
    gameDetail: {
      toggle: "Add game detail",
      toggleHint: "Optional: tap a completed game to record the exact score reached by the player who lost it.",
      gameN: "Game {{n}}",
      openSheet: "Add game detail",
      youServed: "you served", oppServed: "opponent served",
      held: "held", wasBroken: "you were broken", oppHeld: "opponent held", youBroke: "you broke",
      question: "How far did the losing player get?",
      deuce: "Deuce",
      gamePointQuestion: "Did the losing player have a game point?",
      yes: "Yes", no: "No",
      clearDetail: "Clear detail", changeResult: "Change result",
      hold: "Hold", break: "Break", clearResult: "Clear result",
      token: { "0": "Loser reached 0", "15": "Loser reached 15", "30": "Loser reached 30", D: "Deuce, no game point", DG: "Deuce, had a game point" },
    },
  },
  matches: {
    title: "Matches", subtitle: "Your full history. Filter & explore.",
    searchOpponent: "Search opponent", searchPlaceholder: "e.g. Smith",
    format: "Format", confrontation: "Kind",
    matchesCount: "{{count}} matches",
    none: "No matches", new: "+ New",
    setGameByGame: "Set {{n}} — game by game",
    confirmDelete: "Delete match? This cannot be undone.",
    deleted: "Deleted",
    singular: "Singles", duplet: "Doubles", official: "Official", friendly: "Friendly",
  },
  stats: {
    perGameSelectionDetails: "{{wins}} successful out of {{total}} recorded games",
    trendSelectedMatch: "Selected match",
    trendOpenMatch: "View match",
    tempStepLabel: "Temperature interval (°C)",
    ageStepLabel: "Age interval (years)",
    experienceStepLabel: "Experience interval (years)",
    byMyBmiHint: "BMI = weight (kg) / height² (m²). Based on your profile height and your weight recorded in each match.",
    byMyBmiNone: "No personal BMI measurements. Add your height in Settings and your weight per match.",
    bmiBucketSize: "BMI interval",
    bmiSmallSampleHint: "Hover/tap a bar for wins and matches. Very narrow intervals with few matches are not reliable predictors.",
    startTimeHalfHourHint: "Win rate by 30-minute start-time interval (18:30 covers 18:30–18:59).",
    title: "Stats", subtitle: "Deep dive into the numbers.",
    none: "No matches with scores yet.",
    allOpponents: "All opponents",
    serviceStats: "Service stats", returnStats: "Return stats",
    holds: "Holds", breaksAgainst: "Breaks against me", holdRate: "Hold rate ({{n}} games)",
    gamesIServed: "Games I served", holdRateOnServe: "Hold rate on my serve",
    gamesIReceived: "Games I received", opponentHolds: "Opponent holds", breaksIDid: "Breaks I did",
    breaksWon: "Breaks won", breakRate: "Break rate ({{n}} return games)",
    smartwatch: "Smartwatch stats", smartwatchHint: "Averages from your watch screenshots.",
    avgKcal: "Avg calories", avgDuration: "Avg duration", avgBpm: "Avg BPM", maxBpm: "Max BPM (avg)",
    perfReport: "Performance report",
    perfHint: "Average ratings (1–10) across all matches you've rated.",
    perfNone: "You haven't added ratings yet.",
    trendTitle: "Win rate trend", h2h: "Head-to-head",
    byCourt: "Win rate by court", byDay: "Win rate by day",
    bySurface: "Win rate by surface", byTemp: "Win rate by temperature",
    surfaceNone: "No surface recorded yet.", tempNone: "No temperature recorded yet.",
    perGame: "Per-game success", set: "Set", scope: "Scope",
    scopeAll: "Overall", scopeServing: "Started serving", scopeReturning: "Started receiving",
    metricWin: "Win rate", metricHold: "Hold rate (when serving)",
    fullTab: "Full", allSet: "All sets",
    perGameHint: "Success rate per game number.",
    firstBreakTitle: "Win rate by first break", firstBreakHint: "Does landing the first break decide the outcome?",
    fbMe: "I broke first", fbOpp: "Opponent broke first", allSurfaces: "All surfaces",
    firstServerTitle: "Win rate by first server", firstServerHint: "Does starting to serve affect your outcome?",
    fsMatch: "Whole match", fsMe: "I started serving", fsOpp: "Opponent started serving",
    returnGames: "Return games", breakRateLabel: "Break rate", gameNumber: "Game",
    hrZonesAvg: "Average heart-rate zones",
    hrZonesAvgHint: "Mean minutes per zone across {{n}} matches with watch data.",
    byYear: "Win rate by year", byMonth: "Win rate by month",
    byCategoryKind: "Win rate by category & kind",
    byOppAge: "Win rate by opponent age", byOppAgeHint: "Bucketed by age range.", byOppAgeNone: "No opponent age recorded yet.",
    byOppExp: "Win rate by opponent experience", byOppExpHint: "Years playing tennis.", byOppExpNone: "No opponent experience recorded yet.",
    byOppLevel: "Win rate by opponent level", byOppLevelHint: "Overall opponent strength (1–10).", byOppLevelNone: "No opponent level recorded yet.",
    byOppBmi: "Win rate by opponent BMI", byOppBmiHint: "Body Mass Index = weight (kg) / height² (m²).", byOppBmiNone: "No opponent BMI data recorded yet. Add opponent height and weight to see this chart.",
    showTrend: "Show trend", hideTrend: "Hide trend",
    byOppBackhand: "Win rate by opponent backhand", byOppBackhandNone: "No opponent backhand recorded yet.",
    byBalls: "Win rate by ball state", byBallsNone: "No ball state recorded yet.",
    ballsNew: "New", ballsUsed: "Used", ballsUsedN: "Used ×{{count}}",

    byRainy: "Win rate by rain", byFloodlights: "Win rate by floodlights",
    byDuration: "Win rate by match duration", byStartTime: "Win rate by start time",
    byMyBmi: "Win rate by my BMI",
    byOppHandedness: "Win rate by opponent handedness", byOppPlaystyle: "Win rate by opponent playstyle",
    byOppBirthMonth: "Win rate by opponent birth month",
    bySleep: "Win rate by sleep hours", byTiringDay: "Win rate after tiring day",
    byNapped: "Win rate when napped", byHeavyMeal: "Win rate after heavy meal",
    byFasted: "Win rate when fasted", byAnxious: "Win rate when anxious",
    byCondition: "Win rate by physical conditions", byPartner: "Win rate by partner",
    gameDetail: {
      whenServing: "When I served", whenReturning: "When I returned",
      held: "Held", broken: "Broken", opponentHeld: "Opponent held", iBroke: "I broke",
      deuce: "Deuce", pressure: "Pressure",
      serviceCoverage: "Detail recorded for {{detailed}} of {{total}} service games",
      returnCoverage: "Detail recorded for {{detailed}} of {{total}} return games",
      smallSample: "Small sample · n={{count}}",
      noServiceData: "No detailed service games yet", noReturnData: "No detailed return games yet",
      unlock: "Add game detail while logging to see this breakdown.",
      serviceTooltip: "{{percentage}}% · {{count}} of {{total}} detailed service games",
      returnTooltip: "{{percentage}}% · {{count}} of {{total}} detailed return games",
      serviceHeld: { "0": "Held with the returner at 0", "15": "Held with the returner at 15", "30": "Held with the returner at 30", D: "Held after deuce", DG: "Held after facing a break point" },
      serviceBroken: { "0": "Broken with me at 0", "15": "Broken with me at 15", "30": "Broken with me at 30", D: "Broken after deuce", DG: "Broken after having a game point" },
      returnHeld: { "0": "Opponent held with me at 0", "15": "Opponent held with me at 15", "30": "Opponent held with me at 30", D: "Opponent held after deuce", DG: "Opponent held after I had a break point" },
      returnBreak: { "0": "Broke with opponent at 0", "15": "Broke with opponent at 15", "30": "Broke with opponent at 30", D: "Broke after deuce", DG: "Broke after opponent had a game point" },
    },
  },
  theme: { label: "Theme", court: "Court Night", clay: "Clay", daylight: "Daylight", grass: "Grass", hardcourt: "Hardcourt" },
  insights: {
    pageSubtitle: "AI-powered analysis of your matches.",
    pickOpponent: "Opponent",
    title: "Insights", subtitle: "Patterns from your data + AI coach.",
    askAi: "Ask AI", generating: "Generating…", aiNarrative: "AI narrative",
    notEnough: "Not enough data yet — keep logging matches.",
    aiError: "Could not generate AI insights.",
  },
  insightsPreview: {
    title: "What Tennis Log will discover",
    subtitle: "Log your matches and Tennis Log gradually learns the patterns behind your results.",
    learningTitle: "What Tennis Log is learning next",
    learningSubtitle: "These areas need a bit more match history before Tennis Log can say anything about them.",
    examplesLabel: "Examples of what Tennis Log can discover",
    badge: "Example",
    cta: "Log your first match",
    disclaimer: "These are illustrative examples, not conclusions about you. They are not based on your data.",
    items: {
      serve: { text: "You perform better in close matches when your first serve is working.", unlock: "Log serve ratings across a few matches to unlock this." },
      opponents: { text: "Your results against stronger opponents are improving.", unlock: "Log a few more matches with opponent level to unlock this." },
      pressure: { text: "Your unforced errors increase in high-pressure sets.", unlock: "Log a few more matches to discover whether pressure affects your performance." },
      surface: { text: "You win more often on one surface than another.", unlock: "Log matches on different surfaces to unlock this." },
    },
  },
  gaps: {
    title: "What Tennis Log Still Doesn't Know",
    subtitle: "The more complete your match logs become, the smarter your personal AI coach gets.",
    knowledgeTitle: "AI knowledge",
    knowledgeHint: "An estimate of how much useful information is available for meaningful AI analysis.",
    loggedIn: "Logged in {{pct}}% of your matches.",
    notYet: "Not enough data yet.",
    couldReveal: "Tennis Log could reveal:",
    cta: "Start logging this",
    doneTitle: "Excellent!",
    doneBody: "Tennis Log already has enough data to produce high-quality AI insights. Keep logging matches to improve confidence and discover new long-term patterns.",
    items: {
      selfRatings: {
        label: "Your own ratings",
        bullets: ["which shots really decide your matches", "how your level shifts across sets", "progress over the season"],
      },
      opponentRatings: {
        label: "Opponent ratings",
        bullets: ["strengths that matter most against stronger opponents", "weaknesses that appear only against similar-level players", "personalised matchup analysis"],
      },
      sleep: {
        label: "Sleep",
        bullets: ["whether sleep affects your win rate", "your endurance", "your third-set performance"],
      },
      nutrition: {
        label: "Nutrition",
        bullets: ["how meals affect performance", "whether heavy meals reduce your consistency", "how fasting changes your endurance"],
      },
      weather: {
        label: "Weather & conditions",
        bullets: ["how sun, wind or rain change your game", "performance under floodlights", "your best temperature range"],
      },
      court: {
        label: "Court & balls",
        bullets: ["your strongest surface", "how ball condition affects your rhythm", "which venues suit your game"],
      },
      emotions: {
        label: "Mind & energy",
        bullets: ["how nerves affect close sets", "the impact of a tiring day", "when calmness turns matches around"],
      },
      watch: {
        label: "Smartwatch",
        bullets: ["fatigue detection", "recovery patterns", "heart-rate and intensity correlations"],
      },
    },
  },
  composite: {
    title: "Composite Insights",
    subtitle: "Patterns that only appear when several signals from your matches are combined.",
    disclaimer: "Composite insights describe correlations in your own data, not proven causes. They appear only when the sample and effect size are large enough.",
    showMore: "Show {{count}} more insights",
    showLess: "Show fewer",
    direction: {
      positive: "Positive finding",
      negative: "Negative finding",
      neutral: "Neutral finding",
    },
    cat: {
      momentum: "Momentum & match flow",
      context: "Context performance",
      opponent: "Opponent intelligence",
      physical: "Physical readiness",
      development: "Development",
      matchup: "Match-up intelligence",
    },
    ev: {
      groups: "You won {{aWins}} of {{aSample}} matches ({{aRate}}%) {{aLabel}}, compared with {{bWins}} of {{bSample}} ({{bRate}}%) {{bLabel}}.",
      single: "You won {{aWins}} of {{aSample}} matches ({{aRate}}%).",
      ratingTrend: "Average self-rating {{recentAvg}} across your last {{recentN}} matches, compared with {{prevAvg}} across the {{prevN}} before those.",
    },
    grp: {
      metricAbove: "when you rated this above your own average: {{skill}}",
      metricBelow: "when you rated it at or below your average",
      metricAboveSurface: "on {{surface}} when you rated this above your own average: {{skill}}",
      metricBelowSurface: "on {{surface}} when you rated it at or below your average",
      lostFirstSet: "after losing the first set",
      wonFirstSet: "after winning the first set",
      long: "in matches over 90 minutes",
      short: "in matches under 90 minutes",
      decider: "in matches that went to a deciding set",
      overall: "across all your logged matches",
      tiebreak: "in matches with a tie-break",
      surfaceOn: "on this surface: {{surface}}",
      surfaceOff: "on other surfaces",
      morning: "in morning matches",
      afternoon: "in afternoon and evening matches",
      floodlit: "under floodlights",
      daylight: "in daylight",
      skillBetter: "when you rated yourself higher in this area: {{skill}}",
      skillWorse: "when your opponent rated higher in that area",
      goodSleepLong: "in long matches after 7h+ sleep",
      lowSleepLong: "in long matches after less sleep",
      goodSleepDecider: "in deciding-set matches after 7h+ sleep",
      lowSleepDecider: "in deciding-set matches after less sleep",
      heavyMeal: "after a heavy meal",
      noHeavyMeal: "without a heavy meal",
      recentPeriod: "in your last {{n}} matches",
      previousPeriod: "in the {{n}} matches before those",
      h2hLostFirst: "against this opponent after losing the first set",
      h2hOverall: "against this opponent overall",
    },
    msg: {
      mentalPressureStrong: "In pressure moments your mental side decides the match: {{skill}} — you won {{wins}} of {{sample}} such matches ({{rate}}%) when you rated it above your average, against {{otherWins}} of {{otherSample}} ({{otherRate}}%) when you did not.",
      mentalPressureWeak: "In pressure moments your mental side is costing you: {{skill}} — you won {{wins}} of {{sample}} such matches ({{rate}}%) when you rated it above your average, against {{otherWins}} of {{otherSample}} ({{otherRate}}%) when you did not.",
      serveTightStrong: "In tight sets your serve does the work: {{skill}} — {{wins}} of {{sample}} won ({{rate}}%) when you rated it above your average, against {{otherWins}} of {{otherSample}} ({{otherRate}}%) when you did not.",
      serveTightWeak: "Tight sets expose one part of your serve: {{skill}} — {{wins}} of {{sample}} won ({{rate}}%) when you rated it above your average, against {{otherWins}} of {{otherSample}} ({{otherRate}}%) when you did not.",
      techniqueSurfaceStrong: "On {{surface}} one part of your game decides the result: {{skill}} — {{wins}} of {{sample}} won ({{rate}}%) when you rated it above your average, against {{otherWins}} of {{otherSample}} ({{otherRate}}%) when you did not.",
      techniqueSurfaceWeak: "On {{surface}} one part of your game is holding you back: {{skill}} — {{wins}} of {{sample}} won ({{rate}}%) when you rated it above your average, against {{otherWins}} of {{otherSample}} ({{otherRate}}%) when you did not.",
      comebackStrong: "You recover well after losing the first set — you won {{wins}} of {{sample}} such matches ({{rate}}%).",
      comebackWeak: "You currently struggle to recover after losing the first set — you won {{wins}} of {{sample}} such matches ({{rate}}%).",
      fadeLong: "You fade in long matches — {{wins}} wins in {{sample}} matches over 90 minutes ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) in shorter ones.",
      thriveLong: "Long matches suit you — {{wins}} wins in {{sample}} matches over 90 minutes ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) in shorter ones.",
      deciderStrong: "You lift your level in deciding sets — you won {{wins}} of {{sample}} matches that went the distance ({{rate}}%), above your overall {{baseline}}%.",
      deciderWeak: "Deciding sets cost you — you won {{wins}} of {{sample}} matches that went the distance ({{rate}}%), below your overall {{baseline}}%.",
      tiebreakStrong: "Tie-breaks work in your favour — you won {{wins}} of {{sample}} matches featuring one ({{rate}}%), above your overall {{baseline}}%.",
      tiebreakWeak: "Tie-breaks are costing you matches — you won {{wins}} of {{sample}} matches featuring one ({{rate}}%), below your overall {{baseline}}%.",
      surfaceStrong: "This surface suits your game: {{surface}} — {{wins}} wins in {{sample}} matches there ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) elsewhere.",
      surfaceWeak: "This surface is your hardest one: {{surface}} — {{wins}} wins in {{sample}} matches there ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) elsewhere.",
      morningBetter: "Morning matches bring your best results — {{wins}} of {{sample}} ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) later in the day.",
      eveningBetter: "You play better later in the day — {{wins}} of {{sample}} ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) in the morning.",
      floodlightsBetter: "Your game holds up under floodlights — {{wins}} of {{sample}} ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) in daylight.",
      floodlightsWorse: "Floodlit matches are harder for you — {{wins}} of {{sample}} ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) in daylight.",
      strongOppSkill: "Against stronger opponents one area decides the match: {{skill}} — you won {{wins}} of {{sample}} matches ({{rate}}%) when you rated yours above theirs.",
      strongOppWeak: "Against stronger opponents, rating yourself higher in one area has not been enough: {{skill}} — {{wins}} of {{sample}} matches won ({{rate}}%).",
      peerOppSkill: "Against opponents at your own level one area gives you the edge: {{skill}} — {{wins}} of {{sample}} matches won ({{rate}}%).",
      sleepLongMatches: "In long matches sleep shows up in the results — {{wins}} of {{sample}} won after 7h+ sleep ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) with less.",
      fatigueThirdSet: "In matches that reach a deciding set — {{wins}} of {{sample}} won after 7h+ sleep ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) with less.",
      mealStrongOpp: "Against stronger opponents, eating heavily before play shows up — {{wins}} of {{sample}} won without a heavy meal ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) with one.",
      skillRising: "One area is trending up: {{skill}} — about +{{diff}} rating points across your last {{sample}} matches.",
      skillFalling: "One area is trending down: {{skill}} — about -{{diff}} rating points across your last {{sample}} matches.",
      formUp: "Your recent form is up — you won {{wins}} of your last {{sample}} matches ({{rate}}%), compared with {{otherWins}} of the previous {{otherSample}} ({{otherRate}}%), against opponents of similar level.",
      formDown: "Your recent form has dipped — you won {{wins}} of your last {{sample}} matches ({{rate}}%), compared with {{otherWins}} of the previous {{otherSample}} ({{otherRate}}%), against opponents of similar level.",
      matchupSkill: "Against {{opponent}} one area decides the meetings: {{skill}} — {{wins}} of {{sample}} won ({{rate}}%) when you rated yours above theirs.",
      matchupFirstSet: "Against {{opponent}} a lost first set is hard to turn around — {{wins}} of {{sample}} won ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) in all your meetings.",
      matchupComeback: "Against {{opponent}} a lost first set decides nothing — {{wins}} of {{sample}} won ({{rate}}%), against {{otherWins}} of {{otherSample}} ({{otherRate}}%) in all your meetings.",
    },
  },
  coach: {
    driverTitle: "Key performance driver",
    driverLead: "One area decides most of your matches, in both directions: {{topic}}.",
    driverSupport: "Counted so far: {{goodWins}} wins in {{goodSample}} matches ({{goodRate}}%) when it went well, against {{badWins}} in {{badSample}} ({{badRate}}%) when it did not.",
    title: "AI Coach Summary",
    subtitle: "The most important things Tennis Log has learned from your matches.",
    notEnough: "Not enough matches yet to draw conclusions — keep logging.",
    strengthTitle: "Biggest strength",
    weaknessTitle: "Biggest weakness",
    possibleStrengthTitle: "Possible strength",
    possibleWeaknessTitle: "Possible area for improvement",
    strengthLead: "Your data indicates that {{topic}} is your biggest strength.",
    weaknessLead: "Your data indicates that {{topic}} is your biggest weakness right now.",
    strengthLeadTentative: "There are early signs that {{topic}} could become a strength, but the sample is still small.",
    weaknessLeadTentative: "There are early signs that {{topic}} could be an area for improvement, but the sample is still small.",
    focusTitle: "Next match focus",
    focusOne: "For your next match, focus primarily on {{first}}.",
    focusTwo: "For your next match, focus primarily on {{first}}, while keeping {{second}} as your reliable weapon.",
    disclaimer: "These are emerging patterns in your own data, not proven cause and effect.",
    confidence: {
      high: "High confidence",
      medium: "Medium confidence",
      low: "Low confidence",
    },
  },
  watch: {
    uploadScreenshot: "Upload screenshot", uploading: "Uploading...", aiExtracting: "AI extracting...",
    removeImage: "Remove image", imageRequired: "Pick an image (PNG/JPG)",
    uploadFailed: "Upload failed", extractFailed: "AI extract failed",
    extracted: "Data extracted from screenshot!",
    sourcesHint: "From Mi Fitness, Garmin, Apple Watch, Zepp etc. Fields auto-fill via AI.",
    multipleHint: "You can upload more than one screenshot.",
    screenshotAlt: "Smartwatch workout screenshot",
    kcal: "Calories (kcal)", duration: "Duration (min)", avgBpm: "Avg BPM", maxBpm: "Max BPM",
    hrZones: "Heart-rate zones", notes: "Watch notes", notesPlaceholder: "Training effect, recovery, etc.",
  },
  surfaces: { hard: "Hard", clay: "Clay", grass: "Grass", carpet: "Carpet" },
  ad: { label: "Advertisement" },
  footer: {
    rights: "All rights reserved.",
    contact: "Contact", contactTitle: "Contact Tennis Ledger",
    contactHint: "Send us a message — we'll reply to your email.",
    yourEmail: "Your email", subject: "Subject", message: "Message", send: "Open email",
  },
  install: {
    iosCta: "Install on iPhone",
    platforms: "Available on Android · Works on iPhone",
    iosSheetTitle: "Use Tennis Log like an app",
    iosSheetIntro: "Add Tennis Log to your Home Screen in a few taps — no App Store needed.",
    iosSheetStep1: "Open Tennis Log in Safari",
    iosSheetStep2: "Tap the Share button",
    iosSheetStep3: "Tap “Add to Home Screen”",
    iosSheetStep4: "Tap “Add”",
    iosReassurance: "Tennis Log will appear on your Home Screen and open like an app.",
    iosNonSafari: "To install Tennis Log on your iPhone, open this page in Safari.",
    iosNonSafariHint: "Tap the browser menu and choose “Open in Safari”, then use Share → Add to Home Screen.",
    iosNudgeTitle: "Keep Tennis Log one tap away",
    iosNudgeBody: "Add Tennis Log to your Home Screen for an app-like experience.",
    iosNudgeShowMe: "Show me how",
    iosNudgeDismiss: "Not now",
    cta: "Install app",
    loading: "Install option is loading, please wait a few seconds",
    opening: "Opening install prompt…",
    unavailable: "Install option is not available right now",
    title: "Install Tennis Log",
    hint: "Add Tennis Log to your device to open it like a real app.",
    iosStep1: "Tap Share",
    iosStep2: "Then choose Add to Home Screen.",
    iosStep3: "Tap 'Add' in the top right",
    androidStep1: "Tap the browser menu ⋮",
    androidStep2: "Choose Install app or Add to Home screen.",
    androidStep3: "Confirm to install",
    desktopHint: "On Desktop Chrome or Edge:",
    desktopStep1: "Click the install icon in the address bar",
    desktopStep2: "Or open the browser menu and choose Install Tennis Log.",
  },

  profileSetup: {
    "title": "Complete your player profile",
    "subtitle": "A few details make your stats and AI insights far more accurate.",
    "dob": "Date of birth",
    "level": "Your level (1–10)",
    "levelHint": "1 = just starting out, 10 = high-level competitive player.",
    "unitsMetric": "Metric",
    "unitsUs": "US",
    "later": "Later",
    "saved": "Profile updated",
    "ctaTitle": "Complete your player profile",
    "ctaBody": "Takes about a minute and sharpens every comparison in your stats.",
    "ctaAction": "Complete profile",
    "countryPlaceholder": "Select country",
    "countrySearch": "Search country…",
    "countryEmpty": "No country found"
  },
  settings: {
    healthConsent: "Health data consent",
    healthConsentActive: "Active: you allow Tennis Log to process the health data you add to your matches.",
    healthConsentInactive: "Not active: smartwatch and heart-rate data are not processed.",
    healthConsentWithdraw: "Withdraw consent",
    healthConsentWithdrawn: "Consent withdrawn and health data deleted.",
    healthConsentPartial: "Consent withdrawn. Some health data could not be deleted yet — please try again shortly.",
    healthConsentError: "Could not update your consent. Please try again.",
    healthConsentWithdrawHint: "Withdrawing consent permanently deletes your stored smartwatch screenshots and imported health data (heart rate, calories, etc.).",
    healthConsentWithdrawTitle: "Withdraw health-data consent?",
    healthConsentWithdrawBody: "This will permanently delete your stored smartwatch screenshots and imported health data, including heart-rate and calorie data saved with your matches. This cannot be undone.",
    healthConsentWithdrawKeepMatches: "Your tennis match records themselves will remain; only the stored smartwatch and health-related data will be removed.",
    healthConsentWithdrawConfirm: "Withdraw consent and delete health data",
    title: "Settings",
    profile: "Profile",
    displayName: "Display name",
    age: "Age",
    country: "Country",
    gender: "Gender",
    gender_male: "Male", gender_female: "Female", gender_other: "Other", gender_prefer_not: "Prefer not to say",
    level: "Tennis level",
    level_beginner: "Beginner", level_intermediate: "Intermediate", level_advanced: "Advanced", level_competitive: "Competitive",
    profileSaved: "Profile saved",
    password: "Password",
    newPassword: "New password",
    changePassword: "Change password",
    pwdTooShort: "Password must be at least 6 characters",
    pwdChanged: "Password changed",
    dataExport: "Data export",
    dataExportHint: "Download all {{count}} of your matches as a CSV file.",
    exportCsv: "Export to CSV",
    noMatchesExport: "No matches to export yet.",
    exported: "Exported {{count}} matches",
    units: "Units",
    unitsHint: "Choose how temperatures and weights are shown. Your data is always stored in °C and kg.",
    unitsMetric: "Metric (°C, kg)",
    unitsUs: "US (°F, lb)",
    cookiePrefs: "Cookie preferences",
    cookiePrefsHint: "Update which cookie categories you allow.",
    manageCookies: "Manage cookies",
    diagnostics: "App & Diagnostics",
    diagnosticsHint: "Technical details that help us reproduce a problem. Nothing personal is included.",
    diagnosticsCopy: "Copy diagnostics",
    diagnosticsCopied: "Diagnostics copied to clipboard",
    diagnosticsCopyFailed: "Could not copy — please try again",
    reportProblem: "Report a problem",
    diagnosticsPasted: "Diagnostics copied — paste them into your message.",
    diagLanguage: "Language",
    diagUnits: "Units",
    diagDisplay: "Display mode",
    diagDisplayStandalone: "Installed app (standalone)",
    diagDisplayBrowser: "Browser tab",
    diagBrowser: "Browser",
    diagViewport: "Viewport",
    diagOrientation: "Orientation",
    diagHostname: "Hostname",
    dangerZone: "Danger zone",
    deleteAccount: "Delete my account",
    deleteHint: "Permanently delete your account and all your match data. This cannot be undone.",
    deleteConfirmTitle: "Delete your account?",
    deleteConfirmDesc: "All your matches, profile data, and login will be permanently removed.",
    deleteForever: "Yes, delete forever",
    accountDeleted: "Account deleted",
    handedness: "Handedness", righty: "Right-handed", lefty: "Left-handed", heightCm: "Height ({{unit}})",
  },
  cookies: {
    title: "Your privacy",
    intro: "We use cookies to make the app work and to optionally measure usage. You can choose what to allow.",
    necessary: "Strictly necessary",
    necessaryDesc: "Required for sign-in and core features. Always on.",
    analytics: "Analytics",
    analyticsDesc: "Anonymous usage stats to improve the app.",
    marketing: "Marketing",
    marketingDesc: "Used by ad networks to personalize ads.",
    acceptAll: "Accept all",
    rejectAll: "Reject all",
    customize: "Customize",
    savePrefs: "Save preferences",
  },
  invite: {
    title: "Invite a friend",
    subtitle: "Share My Tennis Ledger — scan the QR or copy the link.",
    copyLink: "Copy link",
    share: "Share",
    copied: "Link copied!",
    shareText: "Track your tennis history with My Tennis Ledger:",
  },
  help: {
    eyebrow: "Help center",
    title: "How Tennis Log works",
    subtitle: "A quick tour of every feature, with screenshots and tips. Click any section below to jump in.",
    tocTitle: "On this page",
    tocTroubleshooting: "Troubleshooting",
    tocWhoFor: "Who is Tennis Log for?",
    tocAbout: "About Tennis Log",
    s1Title: "Getting started",
    s1Body: "Create an account with email or Google. You'll land on the Dashboard — empty for now. Tap “+ New match” to log your first one.",
    s2Title: "The Dashboard",
    s2Body: "Six summaries at the top: Win rate, Sets, Games, Hold rate, Breaks won and Current form. Each reflects your current filter (year, format, kind). Below: your win-rate trend and recent matches.",
    s3Title: "Adding a match",
    s3Body: "On New Match, start by recording the opponent, court and score so the result is not lost. Then use Score Timeline, Opponent, Context, Performance Review and Smartwatch to add the level of detail you actually remember. You can save the core match first and return later to enrich the same record.",
    s4Title: "Matches list",
    s4Body: "Search by opponent, filter by format and kind, and click any row to edit. Bulk actions and CSV export are in Settings.",
    s5Title: "Stats",
    s5Body: "Deep cuts of your data: head-to-head, by court, by surface, by temperature, by year/month, by opponent age & experience, by ball state, even by rainy weather or floodlights.",
    s6Title: "AI Insights",
    s6Body: "Click “Ask AI” to get a coach-style narrative based on your match history. AI analysis is available once you have logged match data and generally becomes more informative as your match history grows. When you request AI Insights, only privacy-filtered, allowlisted match data is sent; personal identifiers are removed or pseudonymized in line with the Privacy Policy.",
    s7Title: "Smartwatch import",
    s7Body: "On the Add Match page, scroll to “Smartwatch data”, upload a screenshot from your watch app and we'll auto-fill kcal, duration, avg/max BPM and HR zones using AI.",
    s8Title: "Export & delete",
    s8Body: "From Settings you can change your password, manage cookies, export everything to CSV, or permanently delete your account.",
    ctaTitle: "Ready to start logging?",
    ctaDesc: "Fast and simple — you'll see your first stats after one match.",
    ctaBtn: "Create your account",
    troubleshootingTitle: "Troubleshooting",
    troubleshootingItems: [
      { q: "I can't sign in", a: "Make sure you're using the same provider you signed up with (email or Google). If you forgot your password, use the password reset link on the sign-in screen. Still stuck? Use the Contact link in the footer with the email you used." },
      { q: "My match didn't save", a: "To save a match, an opponent and court are required. Scores and additional details can be added progressively. If you see a red error toast, the form identifies the missing field. Network issues can also block saves — try again on a stable connection." },
      { q: "AI insights aren't generating", a: "AI insights need at least a handful of logged matches to find patterns. If you have enough data but still see an error, the AI service might be temporarily rate-limited — wait a minute and try again." },
      { q: "Smartwatch screenshot isn't being parsed", a: "The parser works best with clear, high-contrast screenshots from Apple Watch, Garmin, Polar or Fitbit. Crop tightly around the workout summary and make sure heart-rate and duration text is readable." },
      { q: "Stats numbers look wrong", a: "Most stat surprises come from missing serve order in game-by-game matches — without it, the app can't compute holds and breaks. Edit the match and double-check who served first in each set." },
    ],
    whoTitle: "Who is Tennis Log for?",
    whoIntro: "Tennis Log is built for any player who wants to take their tennis a little more seriously than just remembering the score on the way home. It works equally well whether you've been playing for three months or three decades — the depth of the tool scales with the depth of your match log.",
    whoBeginnersTitle: "Beginners",
    whoBeginnersBody: "If you've just started playing, the most useful thing Tennis Log gives you is a simple, structured record of your first matches. You don't need to track holds and breaks yet. Just log opponent, score, surface, and a one-line note. As your history grows, you can compare later matches with earlier ones while taking opponent strength, format and other context into account.",
    whoIntermediateTitle: "Intermediate players",
    whoIntermediateBody: "For club and league players, Tennis Log shines. Game-by-game tracking gives you real hold and break percentages. AI analysis is available once you have logged match data and generally becomes more informative as your match history grows. Surface and opponent filters can help you investigate differences, and a structured match log can give you clearer questions to take into practice or a coaching session.",
    whoCompetitiveTitle: "Competitive players",
    whoCompetitiveBody: "If you compete in tournaments or a serious league, Tennis Log functions as a personal performance database. Track conditions, opponent handedness, ratings for both sides, smartwatch data, mental notes — and slice the resulting stats by year, surface, kind (friendly vs official), partner and more. Export to CSV anytime and bring the data into a coaching session.",
  },
}

data.insightsH = {
  "overall": "Overall win rate",
  "overallDetail": "{{rate}}% across {{sample}} decided matches.",
  "better": "Stronger {{skill}} than opponent",
  "betterDetail": "When you're better at {{skill}}, you win {{rate}}% ({{sample}} matches). Baseline: {{baseline}}%.",
  "worse": "Weaker {{skill}} than opponent",
  "worseDetail": "When you're weaker at {{skill}}, you win {{rate}}% ({{sample}} matches).",
  "condDetail": "{{rate}}% across {{sample}} matches (baseline {{baseline}}%).",
  "cond": {
    "oneHanded": "Vs one-handed backhand",
    "twoHanded": "Vs two-handed backhand",
    "lowSleep": "Low sleep (<6h)",
    "goodSleep": "Good sleep (≥7h)",
    "tiring": "Tiring day",
    "floodlights": "Under floodlights",
    "rainy": "Rainy weather",
    "napped": "Napped at midday",
    "heavyMeal": "Heavy meal",
    "fasted": "Fasted",
    "anxious": "Anxious",
    "newBalls": "New balls",
    "official": "Official matches",
    "friendly": "Friendly matches",
    "singles": "Singles",
    "doubles": "Doubles",
    "surface": "Surface: {{surface}}"
  },
  "skill": {
    "shot_accuracy": "shot accuracy",
    "call_accuracy": "line-call accuracy",
    "confrontational_tendency": "on-court composure with the opponent",
    "forehand": "forehand",
    "backhand": "backhand",
    "service": "service",
    "return": "return",
    "volley": "volley",
    "drop_shot": "drop shot",
    "lob": "lob",
    "stamina": "stamina",
    "speed": "speed",
    "unforced_errors": "error control",
    "winners": "winners",
    "tactics": "tactics",
    "awareness": "court awareness",
    "shot_variety": "shot variety",
    "court_coverage": "court coverage",
    "fh_topspin": "forehand topspin",
    "fh_slice": "forehand slice",
    "bh_topspin": "backhand topspin",
    "bh_slice": "backhand slice",
    "first_serve": "1st serve",
    "first_serve_pct": "1st serve percentage",
    "first_serve_speed": "1st serve speed",
    "second_serve": "2nd serve",
    "second_serve_pct": "2nd serve percentage",
    "second_serve_speed": "2nd serve speed",
    "serve_flat": "flat serve",
    "serve_kick": "kick serve",
    "serve_slice": "slice serve",
    "smash": "smash",
    "passing_shots": "passing shots",
    "composure": "composure",
    "concentration": "concentration",
    "calmness": "calmness",
    "anxiety": "nerve control",
    "confidence": "confidence",
    "fighting_spirit": "fighting spirit",
    "mental_resilience": "mental resilience",
    "belief_pre": "belief before the match",
    "belief_in": "belief during the match"
  }
};
data.days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

data.quicklog = {
  "learnedAccordion": "See what Tennis Log has learned so far",
  "savedIndicator": "Saved",
  "fastTrackEyebrow": "Fast Track",
  "fastTrackTagline": "Log a match in under 30 seconds.",
  "revealMore": "Want richer answers? Reveal more below ↓",
  "bonus": "Bonus",
  "continue": "Continue",
  "meterTitle": "Now, Tennis Log can calculate:",
  "meterSubtitle": "These insights are available today, based on the matches you log.",
  "meterMoreTitle": "Reveal more to answer",
  "meterInfoAria": "About these insights",
  "editScore": "Edit score",
  "timelineNoScore": "No score entered yet",
  "answers": {
    "winRate": "Overall win rate",
    "history": "Match history",
    "gamesPct": "Games winning %",
    "setsPct": "Sets winning %",
    "monthly": "Win rate by month",
    "dayOfWeek": "Win rate by day of week",
    "headToHead": "Head-to-head against this opponent"
  },
  "future": {
    "opponent": "Which opponent profiles suit your game",
    "timeline": "How your matches actually unfold",
    "context": "Which conditions help you play your best",
    "review": "Which of your own skills win you matches",
    "watch": "What your smartwatch says about your effort"
  },
  "stepTitles": {
    "fastTrack": "Fast Track",
    "opponent": "Opponent",
    "timeline": "Score Timeline",
    "context": "Context & Conditions",
    "review": "Rate Your Performance",
    "watch": "Smartwatch"
  },
  "stepIntros": {
    "opponent": "Add opponent details so Tennis Log can build a richer picture of who you play. This makes deeper analysis possible.",
    "timeline": "Log how each set unfolded. This makes deeper analysis of your match patterns possible.",
    "context": "Capture the conditions of the match. This makes deeper context analysis possible.",
    "review": "Rate your own performance. This makes deeper analysis of your skills possible.",
    "watch": "Have a smartwatch? Upload one screenshot and let AI fill everything automatically."
  },
  "stepUnlocksLabel": "You'll start feeding analysis for:",
  "unlocks": {
    "opponent": [
      "Results against left-handed opponents",
      "Results against experienced players",
      "Results by opponent playing style",
      "Results against one-handed backhands"
    ],
    "timeline": [
      "How you win and lose your sets",
      "Break and hold patterns",
      "Serve consistency across sets"
    ],
    "context": [
      "How conditions influence your play",
      "Whether sleep or rest affect results",
      "How weather relates to your performance"
    ],
    "review": [
      "Which skills correlate with your wins",
      "Which weaknesses cost you matches",
      "How your ratings evolve over time"
    ],
    "watch": [
      "Calories and duration",
      "Average and max heart rate",
      "Training load and recovery"
    ]
  },
  "successTitle": "Match saved.",
  "successBody": "Tennis Log can already answer these questions about your tennis:",
  "successCtaMatches": "View my matches",
  "successCtaContinue": "Add more match details — optional",

  "addMoreDetails": "Add more details",
  "finish": "Finish & save",
  "wantRicher": "Want richer answers?",
  "prev": "Back",
  "stepOf": "Step {{current}} of {{total}}",
  "dontShowRewards": "Don't show these again",
  "canLabel": "Tennis Log can already identify:",
  "learnedLabel": {
    "match": "What Tennis Log has learned from this match:",
    "matches": "What Tennis Log has learned from your matches:",
    "tennis": "What Tennis Log knows about your tennis:"
  },
  "hintLabel": "Have another minute?",
  "rewardTitles": {
    "fastTrack": "Match saved!",
    "timeline": "Excellent!",
    "opponent": "Great!",
    "context": "Nice work!",
    "review": "Fantastic!"
  },
  "rewardBodies": {
    "fastTrack": "Your match is now part of your tennis history.",
    "timeline": "Tennis Log now understands much more about how your matches develop.",
    "opponent": "Tennis Log now knows much more about the players you face.",
    "context": "Tennis Log can now connect your performance with the conditions you played in.",
    "review": "Your performance review gives Tennis Log a rich source of long-term insight."
  },
  "rewardHints": {
    "fastTrack": "Complete the next step and Tennis Log will begin discovering:",
    "timeline": "Next you'll help Tennis Log understand your opponents.",
    "opponent": "Next you'll record the match conditions.",
    "context": "✨ Have one more minute? Let's now evaluate the performance of both players.",
    "review": "One last optional step: connect your smartwatch."
  }
};

// --- Progressive logging refinement (conversation-first copy) ---
Object.assign(data.match, {
  "oppGender": "Opponent gender *",
  "genderMale": "Male",
  "genderFemale": "Female",
  "genderOther": "Other",
  "oppLevel": "Overall opponent level",
  "oppLevel1": "Complete beginner",
  "oppLevel5": "Average club player",
  "oppLevel10": "Best I've faced",
  "oppLevelHint": "7 = strong club player · 9 = tournament level",
  "oppBirthYear": "Birth year",
  "oppBirthMonth": "Month",
  "oppBirthDay": "Day",
  "oppTennisSince": "Playing tennis since (year)",
  "oppTennisSinceCompact": "Playing since",
  "oppLegacyValue": "saved earlier",
  "oppBirthInvalid": "Enter a full 4-digit birth year (1900 or later).",
  "oppAgePrev": "Previously recorded age",
  "oppExperiencePrev": "Previously recorded years of experience",
  "oppSinceBeforeBirth": "Playing-since year cannot be earlier than the birth year.",
  "oppSinceFuture": "Playing-since year cannot be in the future.",
  "oppSinceRange": "Enter a full 4-digit year (1900 or later).",
  "oppStyleScore": "Defensive ↔ attacking",
  "oppStyleLegacy": "Previously recorded as: {{value}}",
  "oppLevelAvg": "Average of previous matches: {{value}} ({{n}})",
  "oppLevelHistory": "Level history",
  "oppAttackTags": "How they hurt me",
  "oppErrorTags": "Where they miss",
  "oppTagRemembered": "Seen in an earlier match",
  "attackGroup_serve": "Serve & first strike",
  "attackGroup_shape": "Shot shape",
  "attackGroup_target": "Targeting",
  "errorGroup_technical": "Technical",
  "errorGroup_situational": "Situational",
  "attackTag_big_first_serve": "Big first serve",
  "attackTag_aggressive_return": "Aggressive return",
  "attackTag_serve_volley": "Serve & volley",
  "attackTag_takes_ball_early": "Takes the ball early",
  "attackTag_heavy_topspin": "Heavy topspin",
  "attackTag_frequent_slice": "Frequent slice",
  "attackTag_drop_shots": "Drop shots",
  "attackTag_short_angles": "Short angles",
  "attackTag_effective_lobs": "Effective lobs",
  "attackTag_attacks_my_backhand": "Attacks my backhand",
  "attackTag_attacks_my_forehand": "Attacks my forehand",
  "attackTag_net_rusher": "Comes to the net",
  "attackTag_open_court": "Opens up the court",
  "attackTag_changes_direction": "Changes direction",
  "errorTag_backhand_breaks_down": "Backhand breaks down",
  "errorTag_forehand_breaks_down": "Forehand breaks down",
  "errorTag_high_balls": "Struggles with high balls",
  "errorTag_low_balls": "Struggles with low balls",
  "errorTag_vs_heavy_topspin": "Struggles vs heavy topspin",
  "errorTag_vs_slice": "Struggles vs slice",
  "errorTag_vs_drop_shots": "Struggles vs drop shots",
  "errorTag_volley_errors": "Volley errors",
  "errorTag_return_errors": "Return errors",
  "errorTag_second_serve_errors": "Weak second serve",
  "errorTag_errors_when_rushed": "Errors when rushed",
  "errorTag_errors_on_the_run": "Errors on the run",
  "errorTag_overhits": "Overhits",
  "errorTag_long_rallies": "Errors in long rallies",
  "errorTag_under_pressure": "Errors under pressure",
  "oppLevelEmpty": "Slide to rate this opponent's overall level.",
  "oppLevelDesc_10": "Complete beginner",
  "oppLevelDesc_15": "Just starting to learn",
  "oppLevelDesc_20": "Beginner with little match experience",
  "oppLevelDesc_25": "Developing basic consistency",
  "oppLevelDesc_30": "Casual recreational player",
  "oppLevelDesc_35": "Improving recreational player",
  "oppLevelDesc_40": "Regular recreational player",
  "oppLevelDesc_45": "Solid recreational player",
  "oppLevelDesc_50": "Average club player",
  "oppLevelDesc_55": "Competitive club player",
  "oppLevelDesc_60": "Strong club player",
  "oppLevelDesc_65": "Very strong club player",
  "oppLevelDesc_70": "Advanced club player",
  "oppLevelDesc_75": "Strong local competition player",
  "oppLevelDesc_80": "High-level tournament player",
  "oppLevelDesc_85": "Very strong tournament player",
  "oppLevelDesc_90": "Elite amateur / regional level",
  "oppLevelDesc_95": "Exceptional player",
  "oppLevelDesc_100": "The best player I have faced",
  "oppAttackNotes": "How does this opponent attack?",
  "oppAttackNotesPlaceholder": "e.g. big serve, takes the ball early…",
  "oppErrorNotes": "How does this opponent make mistakes?",
  "oppErrorNotesPlaceholder": "e.g. struggles when pushed on the backhand…"
});
data.quicklog.stepTitles.review = "Player Performance Review";
Object.assign(data.quicklog.stepIntros, {
  "fastTrack": "Just the essentials — about 30 seconds.",
  "timeline": "How did the match unfold?",
  "opponent": "Tell us a little about your opponent.",
  "context": "The small details make the difference.",
  "review": "Rate how both players performed — over time Tennis Log will discover what drives your wins.",
  "watch": "Got a smartwatch? Let Tennis Log fill in the rest."
});
Object.assign(data.quicklog.rewardTitles, {
  "fastTrack": "Perfect!",
  "timeline": "Excellent!",
  "opponent": "Wonderful!",
  "context": "Great!",
  "review": "Excellent work!",
  "watch": "All done!"
});
Object.assign(data.quicklog.rewardBodies, {
  "fastTrack": "Your match is now part of your personal tennis story.",
  "timeline": "Tennis Log now understands much better how your matches unfold.",
  "opponent": "Tennis Log now knows much more about the opponents you face.",
  "context": "Your personal database just got even smarter — Tennis Log can now connect your performance with the conditions.",
  "review": "Your tennis profile just got much richer. So did your opponent's. Tennis Log can now start discovering which skills truly win you matches.",
  "watch": "You've just created one of the most complete match records of your tennis journey. Thank you for helping Tennis Log understand your tennis."
});

data.guest = {
  "tryNow": "Try it now — no account required",
  "tryNowLine1": "Try it now",
  "tryNowLine2": "No account required",
  "badge": "Guest session",
  "sumScore": "Score",
  "sumType": "Match type",
  "saveTitle": "Your first match is ready.",
  "saveSubtitle": "You have already logged your first match. Create a free account to save it permanently and begin building your tennis history.",
  "canTitle": "Tennis Log is already able to calculate",
  "beginningTitle": "This is only the beginning.",
  "beginningBody": "Continue and Tennis Log will learn much more from every match you play.",
  "google": "Continue with Google",
  "createAccount": "Create account",
  "haveAccount": "I already have an account",
  "editAgain": "Edit this match",
  "whyLink": "Why do I need an account?",
  "whyBody": "Your matches belong to you. An account allows Tennis Log to:",
  "whyB1": "save your history",
  "whyB2": "synchronise across devices",
  "whyB3": "build long-term statistics",
  "whyB4": "generate AI insights",
  "persisting": "Saving your match…",
  "successTitle": "Perfect!",
  "successBody": "Your first match is now part of your tennis history.",
  "successContinue": "Add more match details — optional"
};

data.appWelcome = {
  "heading": "Welcome to Tennis Log",
  "subheading": "Your tennis history starts with your next match.",
  "googleCta": "Continue with Google",
  "googleHelper": "Fast, secure and no password to remember.",
  "guestCta": "Start without an account",
  "guestHelper": "Log your first match now. You can secure your data with Google later.",
  "haveAccount": "Already have an account? Sign in",
  "carouselTitle": "What can 25 matches reveal?",
  "carouselSubtitle": "The more you log, the clearer your game becomes.",
  "carouselTitle2": "Your Tennis Log grows with every match",
  "carouselSubtitle2": "Swipe to discover what your statistics can become.",
  "card4": "Every session, calories and heart rate",
  "card5": "Your matches on a calendar",
  "card1": "Your season at a glance",
  "card2": "See how your game is developing",
  "card3": "Discover patterns you cannot see alone",
  "footer": "Free core features • Your data stays yours • Built for club players",
  "prev": "Previous",
  "next": "Next",
  "mini": {
    "winRate": "Win rate",
    "matches": "Matches",
    "sets": "Sets won",
    "trend": "Win-rate trend",
    "you": "You",
    "opponent": "Opponent",
    "serve": "Serve",
    "forehand": "Forehand",
    "backhand": "Backhand",
    "movement": "Movement",
    "strength": "Strength",
    "strengthBody": "You win 78% of matches when you take the first break.",
    "opportunity": "Opportunity",
    "opportunityBody": "Your backhand rating drops in third sets — a fitness or focus pattern."
  }
};

data.consent = { health: { title: "Health data — your explicit consent", body: "Heart rate, heart-rate zones, calories, workout duration and smartwatch screenshots are health data. Tennis Log processes them only if you explicitly allow it, including sending them to an AI provider to generate your insights. This is optional and you can withdraw it any time in Settings, which deletes the health data already stored.", checkbox: "I explicitly consent to Tennis Log processing my health data as described above.", enable: "Enable health data", optional: "Optional — Tennis Log works fully without it.", granted: "Health data enabled.", stale: "The consent text has been updated. Please reload the page and review it.", error: "Could not save your choice. Please try again.", } };

data.share = {
  button: "Share result",
  dialogTitle: "Share result",
  dialogSubtitle: "Create an image of this match for social media. Nothing is uploaded — the image is created on your device.",
  showNames: "Show other players' names",
  showLocation: "Show location",
  saveImage: "Save image",
  shareImage: "Share",
  working: "Creating…",
  saved: "Image saved.",
  shared: "Shared.",
  failed: "Could not create the image. Please try again.",
  shareUnsupported: "This device can't share images — use Save image instead.",
  you: "You",
  yourTeam: "Your team",
  opponent: "Opponent",
  opposingTeam: "Opposing team",
  victory: "Victory",
  defeat: "Defeat",
  draw: "Draw",
  retired: "Retired",
  incomplete: "Incomplete",
  retiredTag: "RET",
};

export default data;
